import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const dialogContent: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: (p) => p.spacing(1),
};

export const headerWrapper: SxStyle = {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  p: 2,
  borderBottom: (p) => `1px solid ${p.palette.grey[300]}`,
};
